(function () {
  const SELECTOR = '[data-related-cover-flow]';

  function initCoverFlow(root) {
    root.querySelectorAll(SELECTOR).forEach((container) => {
      if (container.dataset.rcfInit === 'true') return;
      container.dataset.rcfInit = 'true';

      const viewport = container.querySelector('.related-cover-flow__viewport');
      if (!viewport) return;

      const slides = () => Array.from(viewport.querySelectorAll('.related-cover-flow__slide'));

      const updateActive = () => {
        const layout = container.dataset.ymalDesktopLayout || 'grid';
        if (window.matchMedia('(max-width: 749px)').matches) {
          slides().forEach((slide) => slide.classList.add('is-active'));
          return;
        }
        if (layout === 'grid') {
          slides().forEach((slide) => slide.classList.add('is-active'));
          return;
        }

        const items = slides();
        if (!items.length) return;

        const vpRect = viewport.getBoundingClientRect();
        const center = vpRect.left + vpRect.width / 2;

        let closest = items[0];
        let minDist = Infinity;

        items.forEach((slide) => {
          const rect = slide.getBoundingClientRect();
          const slideCenter = rect.left + rect.width / 2;
          const dist = Math.abs(center - slideCenter);
          if (dist < minDist) {
            minDist = dist;
            closest = slide;
          }
        });

        items.forEach((slide) => {
          slide.classList.toggle('is-active', slide === closest);
        });
      };

      let scrollTimer;
      const onScroll = () => {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(updateActive, 40);
        updateActive();
      };

      viewport.addEventListener('scroll', onScroll, { passive: true });

      slides().forEach((slide) => {
        slide.addEventListener('click', (event) => {
          const layout = container.dataset.ymalDesktopLayout || 'grid';
          if (window.matchMedia('(max-width: 749px)').matches) return;
          if (layout === 'grid') return;
          if (slide.classList.contains('is-active')) return;
          if (event.target.closest('a, button, input, select, label')) return;
          slide.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        });
      });

      const shell = container.closest('.ymal-carousel-shell');
      const prevBtn = shell?.querySelector('[data-ymal-prev]');
      const nextBtn = shell?.querySelector('[data-ymal-next]');

      const scrollBySlide = (direction) => {
        const items = slides();
        if (!items.length) return;
        const step = items[0].offsetWidth || viewport.clientWidth * 0.52;
        viewport.scrollBy({ left: direction * step, behavior: 'smooth' });
      };

      prevBtn?.addEventListener('click', () => scrollBySlide(-1));
      nextBtn?.addEventListener('click', () => scrollBySlide(1));

      updateActive();
      window.requestAnimationFrame(updateActive);
      window.addEventListener('resize', updateActive, { passive: true });
    });
  }

  function scan(node) {
    if (node.nodeType !== 1) return;
    if (node.matches?.(SELECTOR)) initCoverFlow(node.parentElement || document);
    initCoverFlow(node);
  }

  document.addEventListener('DOMContentLoaded', () => initCoverFlow(document));

  document.querySelectorAll('product-recommendations').forEach((el) => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => scan(node));
      });
    });
    observer.observe(el, { childList: true, subtree: true });
  });
})();
